import { ComponentChildren } from 'preact'
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react'

export default function CustomPopover({
  children,
}: {
  children: ComponentChildren
}) {
  return (
    <Popover as="span">
      <PopoverButton className="IconButton" aria-label="Vis beskrivelse">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
        >
          <path
            d="M10 5C10.55 5 11 5.45 11 6V10C11 10.55 10.55 11 10 11C9.45 11 9 10.55 9 10V6C9 5.45 9.45 5 10 5ZM9.99 0C4.47 0 0 4.48 0 10C0 15.52 4.47 20 9.99 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 9.99 0ZM10 18C5.58 18 2 14.42 2 10C2 5.58 5.58 2 10 2C14.42 2 18 5.58 18 10C18 14.42 14.42 18 10 18ZM11 15H9V13H11V15Z"
            fill="#000"
          />
        </svg>
      </PopoverButton>
      <PopoverPanel anchor="bottom" className="PopoverContent">
        {({ close }) => (
          <>
            <div>{children}</div>
            <button
              type="button"
              className="IconButton PopoverClose"
              aria-label="Close"
              onClick={() => close()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <g clipPath="url(#clip0_1_74)">
                  <path
                    d="M18.295 7.115C18.6844 6.72564 18.6844 6.09436 18.295 5.705C17.9056 5.31564 17.2744 5.31564 16.885 5.705L12 10.59L7.115 5.705C6.72564 5.31564 6.09436 5.31564 5.705 5.705C5.31564 6.09436 5.31564 6.72564 5.705 7.115L10.59 12L5.705 16.885C5.31564 17.2744 5.31564 17.9056 5.705 18.295C6.09436 18.6844 6.72564 18.6844 7.115 18.295L12 13.41L16.885 18.295C17.2744 18.6844 17.9056 18.6844 18.295 18.295C18.6844 17.9056 18.6844 17.2744 18.295 16.885L13.41 12L18.295 7.115Z"
                    fill="#000"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1_74">
                    <rect width="24" height="24" rx="5" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </button>
          </>
        )}
      </PopoverPanel>
    </Popover>
  )
}
